class VwStkdepotalepdetayDTO {
    id: number = null;
    depotalepbaslikId?: number = null;
    islemtanimId?: number = null;
    olcubirimId?: number = null;
    miktar?: number = null;
    aciklama?: string = "";
    verilenMiktar?: number = null;
    onayaciklama?: string = "";
    depoaciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    fkRedneden?: number = null;
    rednedenaciklama?: string = "";
    rednedeni?: string = "";
    isteyenMevcut?: number = null;
    istenenMevcut?: number = null;
    olcuBirimAd?: string = "";
    islemAdi?: string = "";
    talepDurum?: string = "";
    fkStkGirisdetay?: number = null;
    girisMevcut?: number = null;
    saklamakosulId?: number = null;
    ambalajMevcudu?: string = "";
    tuketimmiktar?: number = null;
}
export default VwStkdepotalepdetayDTO;